var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, continueBtnText, doneText, hasNarration, hasPrompt, i18n, playinline, prompt, submitUp, tappies, title, undefined) {
jade_mixins["video-stream"] = jade_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
var cloudinaryVideoFolderUrl = config.CLOUDINARY_CDN_URL+config.CLOUDINARY_VIDEO_FOLDER
var streamUrl = ''
if ( videoUrl && videoUrl.indexOf(cloudinaryVideoFolderUrl) > -1)
{
streamUrl = videoUrl.replace(cloudinaryVideoFolderUrl, cloudinaryVideoFolderUrl+'sp_full_hd/')
streamUrl = streamUrl.replace('.mp4', '.m3u8')
}
buf.push("<video" + (jade.attr("webkit-playsinline", playsinline, true, false)) + (jade.attr("controls", controls, true, false)) + " preload=\"auto\"" + (jade.attr("dir", config.direction, true, false)) + (jade.attr("poster", poster, true, false)) + (jade.cls(['video-js',klass], [null,true])) + "><source" + (jade.attr("src", videoUrl, true, false)) + "/>");
if ( streamUrl)
{
buf.push("<source" + (jade.attr("src", streamUrl, true, false)) + "/>");
}
buf.push("</video>");
};
jade_mixins["media-collection-content"] = jade_interp = function(prop, obj, isDetails){
var block = (this && this.block), attributes = (this && this.attributes) || {};
obj = obj || locals;
switch (obj[prop + "Type"]){
case "image":
buf.push("<img" + (jade.attr("src", obj[prop], true, false)) + (jade.cls(['block-v-md',isDetails ? "full-size" : "thumbnail"], [null,true])) + "/>");
  break;
case "audio":
if ( isDetails)
{
buf.push("<audio" + (jade.attr("src", obj[prop], true, false)) + " webkit-playsinline=\"webkit-playsinline\" playsinline=\"playsinline\" preload=\"auto\" controls=\"controls\" class=\"multi-content multi-content-audio full-size\"></audio>");
}
else
{
buf.push("<audio" + (jade.attr("src", obj[prop], true, false)) + " webkit-playsinline=\"webkit-playsinline\" playsinline=\"playsinline\" preload=\"none\" controls=\"controls\" class=\"multi-content multi-content-audio thumbnail\"></audio>");
}
  break;
case "video":
default:
if ( isDetails)
{
jade_mixins["video-stream"](obj[prop], true, true, "multi-content vjs-fluid full-size");
}
else
{
jade_mixins["video-stream"](obj[prop], false, false, "video vjs-fluid multi-content thumbnail");
}
  break;
}
};
buf.push("<div class=\"block-v-lg content-fill text-center\"><div class=\"content-container content-fill\"><div class=\"content-sm-ver content-md-ver content-lg-ver\"><h1 class=\"title slide-down delay-3 tight\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"parent-container content-fill\"><div class=\"tappies-parent content-fill\"><div class=\"row tappies text-center\">");
if ( !!tappies)
{
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var tappy = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','content-fill','col-sm-12','col-lg-8','col-lg-offset-2','slide-up',"delay-" + (i) + ""], [null,null,null,null,null,null,true])) + "><div class=\"tappy-child content-fill block-dk block-sm\">");
jade_mixins["media-collection-content"]("content", tappy, false);
buf.push("<!-- put a transparent overlay on top of each item that--><!-- intercepts the click/tap events--><div class=\"tappy-overlay\"></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var tappy = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','content-fill','col-sm-12','col-lg-8','col-lg-offset-2','slide-up',"delay-" + (i) + ""], [null,null,null,null,null,null,true])) + "><div class=\"tappy-child content-fill block-dk block-sm\">");
jade_mixins["media-collection-content"]("content", tappy, false);
buf.push("<!-- put a transparent overlay on top of each item that--><!-- intercepts the click/tap events--><div class=\"tappy-overlay\"></div></div></div>");
    }

  }
}).call(this);

}
buf.push("</div></div><div class=\"details-parent content-fill\">");
if ( !!tappies)
{
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var tappy = $$obj[i];

buf.push("<div class=\"details content-sm-ver content-md-ver content-lg-ver\">");
jade_mixins["media-collection-content"]("content", tappy, true);
buf.push("<div class=\"caption block-v-md block-h-md text-md\">" + (null == (jade_interp = tappy.caption) ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var tappy = $$obj[i];

buf.push("<div class=\"details content-sm-ver content-md-ver content-lg-ver\">");
jade_mixins["media-collection-content"]("content", tappy, true);
buf.push("<div class=\"caption block-v-md block-h-md text-md\">" + (null == (jade_interp = tappy.caption) ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

}
buf.push("</div></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"playinline" in locals_for_with?locals_for_with.playinline:typeof playinline!=="undefined"?playinline:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"tappies" in locals_for_with?locals_for_with.tappies:typeof tappies!=="undefined"?tappies:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}